import React, { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import SecondaryActionButton from "./SecondaryActionButton";
import PrimaryActionButton from "./PrimaryActionButton";

interface FormActionBarProps {
  primaryLabel: ReactNode;
  leftContent?: ReactNode;
  primaryDisabled?: boolean;
  primaryLoading?: boolean;
  primaryOnClick?: () => void;
  primaryIsSubmit?: boolean;
  onCancel?: () => void;
  variant?: "sticky" | "inline";
}

const FormActionBar: React.FC<FormActionBarProps> = ({
  primaryLabel,
  leftContent,
  primaryDisabled = false,
  primaryLoading = false,
  primaryOnClick,
  primaryIsSubmit = true,
  onCancel,
  variant = "sticky",
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const actions = (
    <div className="flex w-full max-w-[20rem] items-center justify-end gap-3">
      <div className="w-[9rem]">
        <SecondaryActionButton
          label={t("_generic._cancel")}
          onClick={onCancel || (() => navigate(-1))}
        />
      </div>
      <div className="w-[9rem]">
        <PrimaryActionButton
          isButton={!primaryIsSubmit}
          label={primaryLabel}
          disabled={primaryDisabled}
          loading={primaryLoading}
          onClick={primaryOnClick}
        />
      </div>
    </div>
  );

  if (variant === "inline") {
    return (
      <div className="mt-6 flex w-full items-center justify-between gap-4 lg:w-[calc(75%+0.75rem)]">
        <div>{leftContent}</div>
        {actions}
      </div>
    );
  }

  return (
    <div className="mt-6 border-t border-[#E5E7EB] bg-white py-4">
      <div className="flex items-center justify-between gap-4">
        <div>{leftContent}</div>
        {actions}
      </div>
    </div>
  );
};

export default FormActionBar;
